import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { AxiosResponse } from 'axios';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UpdateOwnerPhonePayload {
  ownerId: number;
  phoneNumber: string;
}

export interface UpdateOwnerPhoneResponse {
  id: number;
  phoneNumber: string;
}

// ─── API call ─────────────────────────────────────────────────────────────────

const updateOwnerPhone = async (
  payload: UpdateOwnerPhonePayload,
): Promise<UpdateOwnerPhoneResponse> => {
  const response: AxiosResponse<UpdateOwnerPhoneResponse> =
    await axiosInstance.patch(`/owner-details/${payload.ownerId}`, {
      phoneNumber: payload.phoneNumber,
    });

  return response.data;
};

// ─── Hook ─────────────────────────────────────────────────────────────────────

const useUpdateOwnerPhone = (): UseMutationResult<
  UpdateOwnerPhoneResponse,
  Error,
  UpdateOwnerPhonePayload
> => {
  return useMutation<UpdateOwnerPhoneResponse, Error, UpdateOwnerPhonePayload>({
    mutationFn: updateOwnerPhone,
  });
};

export default useUpdateOwnerPhone;
